import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import DataExplorerPage  from 'components/core/data_explorer/DataExplorerPage';
import TransformationParameterForm from 'components/page/process/variableRetrieval/TransformationParameterForm';
import TransformationTypeParameter from 'components/core/fields/transformation_parameters/TransformationTypeParameter';
import WidthParameter from 'components/core/fields/transformation_parameters/WidthParameter';
import RangeParameter from 'components/core/fields/transformation_parameters/RangeParameter';
import BinAlignmentField from 'components/core/fields/BinAlignmentField';
import InfoMessages from 'components/core/help/InfoMessages';

const formStyles = css`
    padding: 8px 15px;
    .last-row-spacer {
         margin-bottom: 10px;
    }
`;

/**
 * The form that renders detail s for a coordinate system
 */
export default class AdvancedTransformationForm extends TransformationParameterForm {
    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        exploredDatastreams: PropTypes.object,
        siteFacilities: PropTypes.array
    };

    constructor(props) {
        super(props);
        this._initializePropDependentVariables(props);
    }

    componentWillUpdate(nextProps) {
        this._initializePropDependentVariables(nextProps);
    }

    _initializePropDependentVariables(props) {
        this.coordinateSystemName = props.match.params.coordinateSystem;
        this.dimensionName = props.match.params.dimension;
    }

    renderTitle = () => {
        return <span>Transformation Settings: <span className={this.labelStyle}> {this.coordinateSystemName} ({this.dimensionName})</span></span>;
    };

    renderDescription = () => {
        return 'Control how the process will transform your input variable data to fit each output dimension.';
    };

    renderForm = () => {
        return (
            <DataExplorerPage
                process={this.props.process}
                siteFacilitie={this.props.siteFacilities}
                exploredDatastreams={this.props.exploredDatastreams}
            >
                <Flexbox flexDirection={'column'}>
                    <Flexbox flexGrow={1} flexDirection={'column'} className={'advanced-transformation-form'}>
                        <Flexbox className={formStyles} flexDirection={'column'}>
                            <TransformationTypeParameter
                                process={this.props.process}
                                processErrors={this.props.processErrors}
                                coordinateSystemName={this.coordinateSystemName}
                                dimensionName={this.dimensionName}
                                infoBoxText={InfoMessages.transformationType}
                                hasWritePermissions={this.props.hasWritePermissions}
                            />
                        </Flexbox>
                        <Flexbox className={formStyles} flexDirection={'column'}>
                            <BinAlignmentField
                                process={this.props.process}
                                processErrors={this.props.processErrors}
                                coordinateSystemName={this.coordinateSystemName}
                                dimensionName={this.dimensionName}
                                hasWritePermissions={this.props.hasWritePermissions}
                            />
                        </Flexbox>
                        <Flexbox className={formStyles} flexDirection={'column'}>
                            <WidthParameter
                                process={this.props.process}
                                processErrors={this.props.processErrors}
                                coordinateSystemName={this.coordinateSystemName}
                                dimensionName={this.dimensionName}
                                hasWritePermissions={this.props.hasWritePermissions}
                            />
                        </Flexbox>
                        <Flexbox className={formStyles} flexDirection={'column'}>
                            <RangeParameter
                                process={this.props.process}
                                processErrors={this.props.processErrors}
                                coordinateSystemName={this.coordinateSystemName}
                                dimensionName={this.dimensionName}
                                hasWritePermissions={this.props.hasWritePermissions}
                            />
                        </Flexbox>
                    </Flexbox>
                </Flexbox>
            </DataExplorerPage>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/coordinateSystem/AdvancedTransformationForm.js